import React, { useState } from "react";
import axios from "axios"; // For making HTTP requests
import "./InvoiceForm.css"; // Separate CSS for styling


function InvoiceForm({ setShowCombinedContainer, setInvoiceData, setQrString }) {
  // State variables for form inputs
  const [clientId, setClientId] = useState(""); // Initialize clientId as empty
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // State for loading indicator

  // Handle form submission
  // InvoiceForm.jsx
const handleSubmit = async (event) => {
  event.preventDefault();

  if (!clientId || !mobileNumber) {
    setError("Both Client ID and Mobile Number are required.");
    return;
  }

  setError("");
  setLoading(true);

  try {
    const apiUrl = `http://localhost:3338/customer/api/v3.0/customers/${clientId}/invoices/payment`;
    const response = await axios.post(apiUrl, { mobileNumber });

    if (response.status === 200 && response.data.invoiceData) {
      // Use the new callback function
      setShowCombinedContainer(response.data.invoiceData, response.data.qrData.qrString);
    } else {
      setError("Invalid response from server");
    }
  } catch (error) {
    console.error("API Error:", error);
    setError("Failed to verify. Please try again.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="invoice-form-container">
      {/* Left side with the image */}
      <div className="invoice-form-left">
        <img
          src={`${process.env.PUBLIC_URL}/images/invoice.jpg`} // Use dynamic image path
          alt="Invoice Illustration"
          className="invoice-image"
        />
      </div>

      {/* Right side with the form */}
      <div className="invoice-form-right">
        <h2>Enter Your Details</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <div className="form-group">
              <input
                type="text"
                id="clientId"
                aria-label="Client ID"
                placeholder="Enter Client ID"
                value={clientId}
                onChange={(e) => setClientId(e.target.value)} // Allow manual entry
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                id="mobileNumber"
                aria-label="Mobile Number"
                placeholder="Enter Mobile Number"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)} // Update state
              />
            </div>
          </div>

          {/* Display error message */}
          {error && <p className="error-message">{error}</p>}

          <div className="input-group">
            <button type="submit" className="proceed-button" disabled={loading}>
              {loading ? "Loading..." : "Proceed"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InvoiceForm;
